import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  assumption_details: {
    name: 'FCA Field Reference'
  },
  fca_field_reference: {
    name: 'Assumption Details'
  }
};

export function Assumptions({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.ASSUMPTIONS,
    onChangeFund,
    schema: schema.ASSUMPTIONS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.ASSUMPTIONS?.field_names || [],
    columnLables,
    order: 256 as any,
    isMultiFunds,
    funds,
    tableName: 'ASSUMPTIONS',
    onAddColumn,
    onDeleteColumn
  });

  return (
    <Table
      id="fca-reporttables-assumptions-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
